import { IAddUpdateContratoRequest } from "../../../../model/admin-portal/request/add-update-contrato-request";
import { IContratoResponse } from "../../../../model/admin-portal/response/contrato-response";
import { ITipoContratoResponse } from "../../../../model/admin-portal/response/tipo-contrato-response";
import { ISituacaoContratoResponse } from "../../../../model/admin-portal/response/situacao-contrato-response";
import { ILicitacaoLookupResponse } from "../../../../model/admin-portal/response/licitacao-lookup-response";
import { IFornecedorLookupResponse } from "../../../../model/admin-portal/response/fornecedor-lookup-response";
import { ITermPaggedRequest } from "../../../../model/admin-portal/request/term-pagged-request";
import { PaginationResponse } from "../../../../model/base/response/pagination-response";

export type ContratosState = {
    dataPaginatedListResponse: PaginationResponse<IContratoResponse>;
    isLoadingData: boolean;
    dataResponse: IContratoResponse | null;
    dataRequest: IAddUpdateContratoRequest;
    showAddEdit: boolean;
    dataSearchRequest: ITermPaggedRequest;
    tiposList: ITipoContratoResponse[];
    situacoesList: ISituacaoContratoResponse[];
    licitacoesList: ILicitacaoLookupResponse[];
    fornecedoresList: IFornecedorLookupResponse[];
};

export const initialDataRequest: IAddUpdateContratoRequest = {
    id: null,
    idLicitacao: null,
    idFornecedor: null,
    idTipoContrato: null,
    idSituacaoContrato: null,
    numContrato: '',
    numProcessoAdministrativo: '',
    textoObjetoContrato: '',
    valorContrato: 0,
    dtaAssinatura: '',
    dtaInicioVigencia: '',
    dtaFimVigencia: '',
    dtaPublicacao: '',
    pncpUrl: '',
    documentos: []
};

export const initialState: ContratosState = {
    dataPaginatedListResponse: new PaginationResponse<IContratoResponse>(),
    isLoadingData: false,
    dataResponse: null,
    dataRequest: initialDataRequest,
    showAddEdit: false,
    dataSearchRequest: { page: 0, pageSize: 10, term: '' },
    tiposList: [],
    situacoesList: [],
    licitacoesList: [],
    fornecedoresList: []
};

export enum ACTION_TYPES {
    setDataPaginatedListResponse = 'setDataPaginatedListResponse',
    setIsLoadingData = 'setIsLoadingData',
    setDataResponse = 'setDataResponse',
    setDataRequest = 'setDataRequest',
    setShowAddEdit = 'setShowAddEdit',
    setDataSearchRequest = 'setDataSearchRequest',
    setTiposList = 'setTiposList',
    setSituacoesList = 'setSituacoesList',
    setLicitacoesList = 'setLicitacoesList',
    setFornecedoresList = 'setFornecedoresList'
}

type Action =
    | { type: ACTION_TYPES.setDataPaginatedListResponse; payload: PaginationResponse<IContratoResponse> }
    | { type: ACTION_TYPES.setIsLoadingData; payload: boolean }
    | { type: ACTION_TYPES.setDataResponse; payload: IContratoResponse | null }
    | { type: ACTION_TYPES.setDataRequest; payload: IAddUpdateContratoRequest }
    | { type: ACTION_TYPES.setShowAddEdit; payload: boolean }
    | { type: ACTION_TYPES.setDataSearchRequest; payload: ITermPaggedRequest }
    | { type: ACTION_TYPES.setTiposList; payload: ITipoContratoResponse[] }
    | { type: ACTION_TYPES.setSituacoesList; payload: ISituacaoContratoResponse[] }
    | { type: ACTION_TYPES.setLicitacoesList; payload: ILicitacaoLookupResponse[] }
    | { type: ACTION_TYPES.setFornecedoresList; payload: IFornecedorLookupResponse[] };

export const contratosReducer = (state: ContratosState, action: Action): ContratosState => {
    switch (action.type) {
        case ACTION_TYPES.setDataPaginatedListResponse:
            return { ...state, dataPaginatedListResponse: action.payload };
        case ACTION_TYPES.setIsLoadingData:
            return { ...state, isLoadingData: action.payload };
        case ACTION_TYPES.setDataResponse:
            return { ...state, dataResponse: action.payload };
        case ACTION_TYPES.setDataRequest:
            return { ...state, dataRequest: action.payload };
        case ACTION_TYPES.setShowAddEdit:
            return { ...state, showAddEdit: action.payload };
        case ACTION_TYPES.setDataSearchRequest:
            return { ...state, dataSearchRequest: action.payload };
        case ACTION_TYPES.setTiposList:
            return { ...state, tiposList: action.payload };
        case ACTION_TYPES.setSituacoesList:
            return { ...state, situacoesList: action.payload };
        case ACTION_TYPES.setLicitacoesList:
            return { ...state, licitacoesList: action.payload };
        case ACTION_TYPES.setFornecedoresList:
            return { ...state, fornecedoresList: action.payload };
        default:
            return state;
    }
};
